export const headers = [
  { name: 'Título', field: 'title', sortable: true },
  { name: 'Descrição', field: 'description', sortable: false, custom: true },
  { name: 'Link', field: 'link', sortable: false, custom: true },
  { name: 'Ativo', field: 'active', sortable: true, custom: true },
  { name: 'Criado em', field: 'created_at', sortable: true, custom: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
